import script from "./UsersDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersDataTable.vue?vue&type=script&setup=true&lang=js"

import "./UsersDataTable.vue?vue&type=style&index=0&id=3354c430&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3354c430"]])

export default __exports__